import React from 'react';
import {View, Platform} from 'react-native';
import theme from '@/style';
import Button from '@/components/basic/button';
import {goTo} from '@/utils';
import {useTranslation} from 'react-i18next';

interface InvitationCodeMaskProps {
  show: boolean;
}

const InvitationCodeMask: React.FC<InvitationCodeMaskProps> = ({show}) => {
  const {i18n} = useTranslation();

  if (!show) {
    return null;
  }

  return (
    <View
      style={[
        theme.position.abs,
        Platform.select({
          web: {
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.7)',
            backdropFilter: 'blur(2px)',
          },
          default: {
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.7)',
          },
        }),
        theme.flex.center,
      ]}>
      <Button
        buttonStyle={[
          theme.padding.tbxs,
          theme.padding.lr24,
          theme.flex.center,
          // eslint-disable-next-line react-native/no-inline-styles
          {
            borderRadius: 20,
            backgroundColor: '#2DB1A2',
          },
        ]}
        onPress={() => {
          goTo('BindPhone');
        }}
        titleBold
        size="middle"
        title={i18n.t('invitation.getcode.btn')}
      />
    </View>
  );
};

export default InvitationCodeMask;
